import { FeaturedMenu } from './FeaturedMenu';

export * from './FeaturedMenu';

export default FeaturedMenu;
